// https://www.w3schools.com/howto/howto_js_scroll_indicator.asp
$(window).on('scroll', function() {
    // We only want the behavior at smaller screen sizes
    if ($(window).width() < 950) {
        if (getScrollPercentage() > 93) {
            $("#floater").css("opacity",0);
        }
        else {
            $("#floater").css("opacity",1);
        }
    }
});

function getScrollPercentage() {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    return scrolled;
} 

window.getScrollPercentage = getScrollPercentage;